module.exports = __webpack_public_path__ + "static/media/snap.e40237c3.svg";